import React, { Component, Fragment } from 'react'
import { withRouteData, Head } from 'react-static'

import NewFooter from '../../../blocks/NewFooter/NewFooterV2'
import NewMenu from '../../../blocks/Menu/NewMenu'
import DemoForm from '../../../components/site/Forms/DemoForm'
import FormHero from '../../../components/site/FormHero/FormHero'
import TwoColsV2 from '../../../blocks/TwoCols/TwoColsV2'
import IndicatorsGrid from '../../../blocks/IndicatorsGrid/IndicatorsGrid'
import CallToActionSection from '../../../blocks/CallToActionSection/CallToActionSection'

import './SalesForcev3.scss'

class SalesForcev2 extends Component {
    render() {
        return (
            <Fragment>
                {this.props.headData && <Head>
                    <title>{this.props.headData.pageTitle}</title>
                    <meta property="og:title" content={this.props.headData.pageTitle} />
                    <meta name="twitter:title" content={this.props.headData.pageTitle} />
                    <meta name="description" content={this.props.headData.pageDescription} />
                    <meta property="og:description" content={this.props.headData.pageDescription} />
                    <meta name="twitter:description" content={this.props.headData.pageDescription} />
                    <meta property="og:image" content={this.props.headData.ogImage} />
                    <meta name="twitter:image" content={this.props.headData.ogImage} />
                    <meta property="og:url" content={this.props.headData.ogUrl} />
                    <link rel="canonical" href={this.props.headData.ogUrl} />
                    <script type="application/ld+json">
                        {`{
                            "@context": "https://schema.org",
                            "@type": "ImageObject",
                            "contentUrl": "https://mercos.com/images/sistema-de-forca-de-vendas.png",
                            "url": "https://mercos.com/images/sistema-de-forca-de-vendas.png",
                            "name": "Sistema de Força de Vendas",
                            "description": "A imagem mostra alguns dos indicadores do sistema de força de vendas Mercos sendo eles Evolução de Venda, Carteira de Clientes (que contém um gráfico de pizza com Clientes Ativos, Inativos antigos e Recentes e Prospects), E-commerce B2B, valor vendido no mês, situação do cliente nos últimos 6 meses, Pedidos e Atendimentos",
                            "thumbnail": {
                                "@type": "ImageObject",
                                "contentUrl": "https://mercos.com/images/sistema-de-forca-de-vendas.png"
                            },
                            "width": 809,
                            "height": 656,
                            "uploadDate": "2025-08-22",
                            "license": "https://mercos.com/",
                            "author": {
                                "@type": "Organization",
                                "name": "Mercos",
                                "url": "https://www.mercos.com"
                            },
                            "copyrightHolder": {
                                "@type": "Organization",
                                "name": "Mercos"
                            }
                        }`}
                    </script>
                </Head>}

                <div className="new-sales-force-v3">
                    <NewMenu transparentOnTop pixelsToShowMenuWhite={50} mutableMenu hideOnScroll />

                    <FormHero
                        className="new-sales-hero"
                        titleId="sales-force-hero-title"
                        overtitle="Força de vendas"
                        title={<Fragment>Sistema de força de vendas líder <span className="mobile-slim">para indústrias, distribuidoras e representantes</span></Fragment>}
                        description="Automatize sua operação comercial de ponta a ponta com o sistema de força de vendas Mercos: emita pedidos e melhore a gestão de clientes, produtos, equipe e dados, integrando tudo a qualquer ERP"
                        form={<DemoForm showForm inline formHeroStyle title="Fale com um especialista e veja o Mercos na prática" submitButtonText="Solicitar Demonstração" />}
                    />



                    <TwoColsV2
                        overTitle="Força de vendas n°1 do mercado"
                        title="O sistema mais completo para suas vendas"
                        description="Da emissão de pedidos à integração com seu ERP: conte com IA, CRM, controle de estoque e dados em tempo real para uma gestão centralizada e sucesso nas vendas"
                        imageSrc="/images/sistema-de-forca-de-vendas.png"
                        imageAlt="Sistema de Força de Vendas"

                        isImageFullWidth={true}

                        testimonial={{
                            text: "Evoluímos muito a qualidade dos pedidos, desde a emissão até a entrega. Além disso, integramos o Mercos ao nosso ERP e automatizamos nosso fluxo operacional",
                            personName: "Henrique Zompeiro",
                            companyName: "Gerente Financeiro na Corsa Bike",
                            personImage: "/images/site/depoimentos/henrique-zompeiro.png"
                        }}
                        radialBg="purple"
                    />
                    <TwoColsV2
                        overTitle="Automatize seus pedidos com IA"
                        title="Economize 90% do tempo gasto em pedidos"
                        description="Mais vendas, menos esforços: com a IA do Mercos, você emite pedidos em segundos a partir de arquivos recebidos pelo WhatsApp e confere sugestões automáticas para ampliar seu mix de produtos"
                        imageSrc="/images/site/landing-pages/forca-vendas/economize.png"
                        imageAlt='Imagem do sistema de pedidos com IA da Mercos, que oferece automação da força de vendas. É possível ver a tela em que os pedidos que chegam por WhatsApp, e-mail, planilhas, áudios, texto ou PDF são adicionados, permitindo a emissão rápida de pedidos, economizando até 90% de tempo nessa tarefa. Há também os botões "Encontrar produtos", "Cancelar" e "Como funciona", que guiam o usuário pela experiência do recurso.'
                        isReverse={true}
                        testimonial={{
                            text: "Otimizamos bastante o tempo gasto com os muitos pedidos que chegavam pelo WhatsApp. É só copiar e colar a mensagem e, se necessário, ajustar algum item. É rápido, simples e muito eficiente.",
                            personName: "Eduardo Woiciechoski",
                            companyName: "WB Distribuidora"
                        }}
                        radialBg="green"
                    />
                    <TwoColsV2
                        overTitle="Aplicativo Mercos"
                        title="A equipe de vendas no controle das metas"
                        description="Tenha o poder nas mãos com o aplicativo de força de vendas Mercos: acesse políticas comerciais, gerencie clientes, orçamentos e representadas com facilidade e acompanhe suas metas de perto"
                        imageSrc="/images/site/landing-pages/forca-vendas/equipe-de-vendas.png"
                        imageAlt='Imagem do app de força de vendas Mercos mobile. O aplicativo está aberto na tela de orçamento, mostrando um cliente fictício chamado "Cliente B2B". É possível adicionar produtos para emitir um pedido para ele, definir descontos e acréscimos e avaliar detalhes sobre o pedido. Ao lado, há a mensagem "pedido emitido / concluído", mostrando o quanto é fácil realizar a emissão de pedidos pelo sistema de força de vendas Mercos.'
                        testimonial={{
                            text: 'Antes, tínhamos apenas um \'tirador de pedidos\'. Perdíamos muito tempo, o vendedor não tinha acesso a dados em tempo real e não conseguia vender offline. Hoje, é tudo muito rápido. Ganhamos tempo e reduzimos os erros dos processos manuais',
                            personName: "Raimylson Dias",
                            companyName: "Estratégico da Esquadromil",
                            personImage: "/images/site/depoimentos/raimylson-dias.png"
                        }}
                        radialBg="purple"

                    />
                    <TwoColsV2
                        overTitle="Integração total"
                        title="Conectado com as principais ferramentas do mercado"
                        description="Integração com softwares como ERPs, BIs, CRMs e outros, de forma estável, com APIs abertas e suporte técnico real, garantindo eficiência e segurança sem complicações para a TI"
                        imageSrc="/images/site/landing-pages/forca-vendas/conectado.png"
                        imageAlt='Imagem com um compilado de logos de empresas com as quais o Mercos se conecta, por meio de integrações realizadas com APIs abertas, seguras e sem complicações para TI. É possível ver exemplos de ERPs, BIs e CRMs, como Power BI, Tiny, Conta Azul, Sankhya, SAP, Zucchetti, Cigam, entre outros'
                        isReverse={true}

                    />

                    <IndicatorsGrid />

                    <CallToActionSection />

                </div>
                <NewFooter />
            </Fragment>
        )
    }
}

export default withRouteData(props => <SalesForcev2 {...props} />)



// WEBPACK FOOTER //
// /usr/src/site-blog/src/containers/site/recursos/SalesForcev3.jsx